import AccountSettings from "@/components/shared/settings/sections/AccountSettings";
import { HOME_ORG_PATH } from "@/config/constants";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";

const FrontEndAccountSettings = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Account Settings");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Home", path: HOME_ORG_PATH },
            { label: "Settings" },
            { label: "Account" },
        ]);
    });
    return <AccountSettings />;
};

export default FrontEndAccountSettings;
